export default __webpack_public_path__ + "static/media/flexibility.67ad104a.svg";